import * as z from "zod/v4";

export const getTeamAutomations = {
  name: "getTeamAutomations" as const,
  input: z.void(),
  output: z.array(z.object({ id: z.string(), name: z.string() })),
};
